// İş İzni — "hazır değil" sayımı (GitLab #2). TEK kural: sunucunun türettiği `ready` /
// `vehicleReady` (api-contract §14/§17.2, §23) — satır "Eksik" etiketleri ve EP uyarısıyla AYNI
// alan. `ready` belge (onaylı + geçerli + izne özel ek talep) VE eğitim boyutunu zaten kapsar;
// istemci yeniden türetmez. Issue #25 araç hazırlığının KAYNAĞINI değiştirir, alan adlarını değil.

import type { WorkPermitPersonnelDto, WorkPermitVehicleDto } from '../api/permits';

/** Hazır olmayan (belge veya eğitim eksik) personel sayısı. */
export function countNotReadyPersonnel(
  personnel: readonly Pick<WorkPermitPersonnelDto, 'ready'>[],
): number {
  return personnel.filter((p) => !p.ready).length;
}

/** Hazır olmayan (araç belgesi eksik/onaysız) araç sayısı. */
export function countNotReadyVehicles(
  vehicles: readonly Pick<WorkPermitVehicleDto, 'vehicleReady'>[],
): number {
  return vehicles.filter((v) => !v.vehicleReady).length;
}

/** Hazır (belge ve eğitim tamam) personel sayısı. */
export function countReadyPersonnel(
  personnel: readonly Pick<WorkPermitPersonnelDto, 'ready'>[],
): number {
  return personnel.length - countNotReadyPersonnel(personnel);
}

/** Hazır (araç belgeleri tamam) araç sayısı. */
export function countReadyVehicles(
  vehicles: readonly Pick<WorkPermitVehicleDto, 'vehicleReady'>[],
): number {
  return vehicles.length - countNotReadyVehicles(vehicles);
}

/** "n / m" ilerleme metni. Hiçbir şey istenmiyorsa (m = 0) `—`; "0 / 0" başarısızlık gibi okunmasın. */
export function formatProgress(done: number, required: number): string {
  return required > 0 ? `${done} / ${required}` : '—';
}
